export enum EDestinoPaginaZeroDuvidas {
  FORUM = 1,
  CHAT_COM_CORDENADOR = 2,
  CHAT_COM_MEDIADOR = 3,
}

interface AutenticarTutoriaServiceInput {
  urlBase: string;
  token: string;
  destinoPaginaZeroDuvidas?: EDestinoPaginaZeroDuvidas;
  idTurma?: string;
}

interface AutenticarTutoriaServiceResult {
  urlAutenticada: string;
}

export interface AutenticarTutoriaApiResponse {
  urlAutenticada: string;
}

export type AutenticarTutoriaService = (
  props: AutenticarTutoriaServiceInput,
) => Promise<AutenticarTutoriaServiceResult>;
